import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { PageComponent } from './page/page.component';
import { CategoryComponent } from './product/category.component';
import { ProductComponent } from './product/product.component';
import { NewsComponent } from './news/news.component';
import { NewsDetailComponent } from './news/newsdetail.component';
import { GalleryComponent } from './gallery/gallery.component';
import { VideoComponent } from './video/video.component';
import { ContactComponent } from './contact/contact.component';
import { ServiceComponent } from './service/service.component';
import { ServiceDetailComponent } from './service/servicedetail.component'; 
import { RoomlistingComponent } from './hotel/roomlisting.component';
import { RoominfoComponent } from './hotel/roominfo.component';
import { BookingComponent } from './hotel/booking.component';

import { BlogCategoryComponent } from './blog/blogcategory.component';
import { BlogComponent } from './blog/blog.component';
 
        
const appRoutes: Routes = [
    { path: '', component: HomeComponent, 	    
	    data: {
      meta: {
        title: '',
        description: ''
        
      }
    }
    },    
    { path: 'p/:slug',component: PageComponent,
    	data: {
			meta: {
				title: '',
				description: '',
				'og:title':'',				
				'og:description':'',
				'og:url':'',
				'og:image':''
				
        
      }
    } },
    { path: 'c/:slug',component: CategoryComponent },
    { path: 'c/:category/:slug',component: ProductComponent },
    { path: 'product',component: ProductComponent },
    { path: 'n/:slug',component: NewsComponent },
    { path: 'n/:news/:slug',component: NewsDetailComponent },
    { path: 's/:slug',component: ServiceComponent },
    { path: 's/:service/:slug',component: ServiceDetailComponent },
    { path: 'g/:slug',component: GalleryComponent },
    { path: 'v/:slug',component: VideoComponent },
    { path: 'contact-us',component: ContactComponent },
    { path: 'h/:slug',component: RoomlistingComponent },
    { path: 'r/:slug',component: RoominfoComponent },
    { path: 'booking',component: BookingComponent },
    { path: 'b/:slug',component: BlogCategoryComponent },
    { path: 'b/:category/:slug',component: BlogComponent },
    { path: 'blog',component: BlogComponent },
        
];

export const appRoutingProviders: any[] = [];

export const routing = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// ./resources/assets/typescript/app.routing.ts